import React from "react";

export default function WhatsApp() {
  return (
    <div className="fixed right-4 top-1/2 transform -translate-y-1/2 z-50 w-16 h-16  sm:w-20 sm:h-20 bg-slate-400 p-2 cursor-pointer rounded-full hover:bg-[#3C98FF] duration-700">
      <div className="relative group">
        <a href="https://api.whatsapp.com/send?phone=%2B628118112559&app_absent=0" target="_blank" rel="noreferrer">
          <img src="images/whatsapp.svg" alt="Whats App" />
        </a>
        <div className="absolute group-hover:opacity-100 group-hover:pointer-events-auto pointer-events-none duration-300 opacity-0 -left-40 sm:-left-44 rounded-md top-1/2 transform -translate-y-1/2 bg-[#3C98FF] p-2 text-white">
          <span className="whitespace-nowrap text-sm sm:text-base">+62 811-811-2559</span>
        </div>
      </div>
    </div>
  );
}
